import http from "./http";

export function login(payload) {
  return http.post("/admin/login", payload);
}

export function fetchDashboard() {
  return http.get("/admin/dashboard");
}

export function fetchAdminPosts() {
  return http.get("/admin/posts");
}

export function createPost(payload) {
  return http.post("/admin/posts", payload);
}

export function updatePost(id, payload) {
  return http.put("/admin/posts/" + id, payload);
}

export function deletePost(id) {
  return http.delete("/admin/posts/" + id);
}

export function fetchAdminBanners() {
  return http.get("/admin/banners");
}

export function createBanner(payload) {
  return http.post("/admin/banners", payload);
}

export function updateBanner(id, payload) {
  return http.put("/admin/banners/" + id, payload);
}

export function deleteBanner(id) {
  return http.delete("/admin/banners/" + id);
}

export function fetchAdminCompanyInfo() {
  return http.get("/admin/company-info");
}

export function updateCompanyInfo(payload) {
  return http.put("/admin/company-info", payload);
}

export function fetchContacts() {
  return http.get("/admin/contacts");
}

export function updateContactStatus(id, status) {
  return http.put("/admin/contacts/" + id + "/status", { status });
}

export function uploadImage(file) {
  const formData = new FormData();
  formData.append("file", file);

  return http.post("/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

